import { RootState } from '@reducers';

export const selectCancerQuoteResultPage = (state: RootState) => state.cancerQuoteResultPageReducer;
